import { TextField, Typography } from "@mui/material";
import ColumnContainer from "../../common/ColumnContainer";
import InfoModalComponent from "../../dashboardMainLayout/InfoModalComponent";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useState } from "react";
import { FormattedMessage } from "react-intl";
import { useForgotPassword } from "../../../utils/hooks/useForgotPassword";
import { useTheme } from "@mui/material";
import { useSelector } from "react-redux";
import { selectLanguage } from "../../../redux/features/language/languageSlice";
import { Form, useNavigate } from "react-router-dom";
import { commonRoutes } from "../../../utils/routes/Routes";

export const ForgotPassword = ({
  openForgotPasswordModal,
  handleCloseForgotPasswordModal,
}) => {
  const [userData, setUserData] = useState({ email: "" });

  const theme = useTheme();
  const navigate = useNavigate();

  const { forgotPassword, fetchResponseStatus } = useForgotPassword();

  const currentLanguage = useSelector(selectLanguage);

  const handleNavigateToRegister = () => {
    navigate(commonRoutes.register);
  };
  const handleSubmit = async (values) => {
    !fetchResponseStatus.success &&
      forgotPassword({
        email: values.email,
        language: currentLanguage,
      });
  };

  const validationSchema = Yup.object().shape({
    email: Yup.string()
      .email(<FormattedMessage id="login.form.warnings.email" />)
      .required(<FormattedMessage id="login.form.warnings.empty" />),
  });

  const formik = useFormik({
    initialValues: userData,
    validationSchema: validationSchema,
    onSubmit: handleSubmit,
  });

  return (
    <InfoModalComponent
      handleConfirm={formik.handleSubmit}
      confirmButton
      openModal={openForgotPasswordModal}
      handleCloseModal={handleCloseForgotPasswordModal}
    >
      <ColumnContainer align="center">
        <Typography variant="p" component="p">
          <FormattedMessage id="forgotPassword.title" />
        </Typography>

        <form onSubmit={formik.handleSubmit} style={{ width: "100%" }}>
          <ColumnContainer padding={"0px"} minGap>
            {fetchResponseStatus.success ? (
              <Typography variant="p" component="p">
                <FormattedMessage id="forgotPassword.success" />
              </Typography>
            ) : (
              <ColumnContainer halfGap align="start">
                {fetchResponseStatus.error ? (
                  <Typography
                    paragraph
                    className="error-message"
                    style={{
                      color: theme.palette.error.main,
                    }}
                  >
                    <FormattedMessage id="forgotPassword.error" />
                  </Typography>
                ) : null}

                <TextField
                  validateOnChange={false}
                  variant={"outlined"}
                  margin="normal"
                  fullWidth
                  size="small"
                  id="email"
                  label={
                    <FormattedMessage id="login.form.email"></FormattedMessage>
                  }
                  name="email"
                  value={formik.values.email}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.email && Boolean(formik.errors.email)}
                  helperText={formik.touched.email && formik.errors.email}
                  sx={{
                    "& .MuiInputBase-root": {
                      backgroundColor: theme.palette.secondary.main,
                    },
                  }}
                />
                <Typography
                  paragraph
                  className="link-style"
                  fontSize="16px"
                  style={{
                    color: theme.palette.primary.main,
                  }}
                  onClick={handleNavigateToRegister}
                >
                  <FormattedMessage id="forgotPassword.requestAccess"></FormattedMessage>
                </Typography>
              </ColumnContainer>
            )}
          </ColumnContainer>
        </form>
      </ColumnContainer>
    </InfoModalComponent>
  );
};
